import type { FieldSchema } from 'lorena-templates'

interface Props {
  field: FieldSchema
  value: string
  onChange: (value: string) => void
}

export function TextField({ field, value, onChange }: Props) {
  return (
    <div className="field">
      <label htmlFor={field.key}>{field.label}</label>
      <input
        id={field.key}
        type="text"
        placeholder={field.placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      {field.help && <p className="field-help">{field.help}</p>}
    </div>
  )
}
